
<div  v-if="$route.name === 'publish_portal'">
<button type="button" class="btn bg-transparent btn-sm me-3 p-0" data-bs-toggle="modal" data-bs-target="#subject_modal">
  <i class="bi bi-plus-circle-fill fs-3"></i>
</button>
</div>
<div v-else>
<button v-if="user_details.user_role == 'admin'" class="btn bg-transparent btn-sm p-0" type="button" data-bs-toggle="modal" data-bs-target="#subject_modal">
<img src="@/assets/images/plus.png" alt="" class="filter-icon-2">
</button>
</div>
<teleport to="body">
<div class="modal fade" id="subject_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content rounded-5 shadow scrollable-container">
        <div class="modal-header bg-primary position-relative">
          <p class="modal-title text-white text-xs" id="exampleModalLabel">Create a Topic</p>
          <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <form @submit.prevent="createSubject">
          <div class="modal-body">
  
            <div class="mb-3">
              <label for="subject_name" class="form-label text-xs fw-500">Topic Name <span
                  class="text-danger">*</span></label>
              <input type="text" class="form-control rounded-5 text-xs" id="subject_name" placeholder="Enter topic name"
                v-model="subject_name">
                <p v-if="errors.subject_name" class="text-danger text-xs">{{ errors.subject_name }}</p>
            </div>
  
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary text-xs rounded-3 shadow-sm">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>

</teleport>

